<template>
    <div class="Layout">
          <!-- 左边导航 -->
         <Nav />
          <!-- 右边内容 -->
          <Right />
    </div>
</template>

<script>
import Nav from "@/views/Layout/nav.vue"
import Right from "@/views/Layout/Right"
    export default {
        components:{
            Nav,
            Right
        }
        
    }
</script>

<style lang="less" scoped>
.Layout{
    display: flex;
    height: 100%;
}
</style>